import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { isValidPhoneNumber } from '@domains';

// RP-4072: the rule itself moved to @domains so the @rspl-ui phone input can share it —
// `ui` cannot import `@core`. Re-exported here so existing `@core` importers keep working.
export { isValidPhoneNumber };

export function phoneNumberValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (!value) return null;
    return isValidPhoneNumber(value) ? null : { invalidPhone: true };
  };
}
